// ================= GLOBAL AUDIO UNLOCK =================
window.__userInteracted = false;


// ================= VIDEO ELEMENT =================
class VideoElement extends HTMLElement {
  constructor() {
    super();

    this._hasPlayed = false;
    this.paused = false;
    this.isHovering = false;

    const posterButton = this.querySelector('button.media__poster');
    if (posterButton) {
      posterButton.addEventListener('click', this.handlePosterClick.bind(this));
    }

    // --------- INTERSECTION OBSERVER (SCROLL AUTOPLAY) ---------
    if (this.autoplay) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            // hover ke time observer ignore
            if (this.isHovering) return;

            if (entry.isIntersecting && !this.paused) {
              this.play();
            } else {
              this.pause();
            }
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(this);
      this._intersectionObserver = observer;
    }
  }

  get posterElement() {
    return this.querySelector('img');
  }

  get playButtonElement() {
    return this.querySelector('button.media__poster span.media__play-button');
  }

  get autoplay() {
    return this.hasAttribute('autoplay');
  }

  get playing() {
    return this.hasAttribute('playing');
  }

  get video() {
    return this.querySelector('video');
  }

  // --------- PLAY ---------
  play() {
    // ek time pe ek hi video
    document.querySelectorAll('video-element').forEach(el => {
      if (el !== this && el.playing) el.pause();
    });

    if (!this.video || this.playing) return;

    // 🔊 audio rule
    this.video.muted = !window.__userInteracted;
    this.video.playsInline = true;

    this.video.play().catch(() => {});
    this.setAttribute('playing', '');
  }

  // --------- PAUSE ---------
  pause() {
    if (this.video && this.playing) {
      this.video.pause();
      this.removeAttribute('playing');
    }
  }

  // --------- CLICK PLAY (AUDIO UNLOCK) ---------
  handlePosterClick(e) {
    e.preventDefault();
    e.stopPropagation();

    window.__userInteracted = true; // 🔓 audio unlock
    this.video.muted = false;

    this.paused = this.playing;
    this.playing ? this.pause() : this.play();
  }

  connectedCallback() {
    if (!this.video) return;

    this.video.addEventListener('play', () => {
      this.setAttribute('playing', '');
      this._hidePoster();
      this._hidePlayButton();
    });

    this.video.addEventListener('pause', () => {
      this.removeAttribute('playing');
      this._showPlayButton();
    });

    // --------- HOVER PLAY (DESKTOP ONLY) ---------
    if (window.matchMedia('(hover: hover)').matches) {
      let hoverTimer;

      this.addEventListener('mouseenter', () => {
        hoverTimer = setTimeout(() => {
          this.isHovering = true;
          this.paused = false;
          this.play();
        }, 120);
      });

      this.addEventListener('mouseleave', () => {
        clearTimeout(hoverTimer);
        this.isHovering = false;
        this.paused = true;
        this.pause();
      });
    }
  }

  _hidePoster() {
    if (this.posterElement) this.posterElement.style.display = 'none';
  }

  _hidePlayButton() {
    if (this.playButtonElement) this.playButtonElement.style.display = 'none';
  }

  _showPlayButton() {
    if (this.playButtonElement) this.playButtonElement.style.display = '';
  }
}

customElements.define('video-element', VideoElement);


// ================= SWIPER SLIDER =================
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll(
    '.video-slider.g-style .products-tabs__layout.swiper'
  );

  sliders.forEach(container => {
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    const swiper = new Swiper(container, {
      slidesPerView: 1.5,
      spaceBetween: 20,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        640: { slidesPerView: 1.5 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1440: { slidesPerView: 4 },
      },
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      on: {
        slideChange: () => {
          document
            .querySelectorAll('video-element')
            .forEach(el => el.pause());
        }
      }
    });

    container.swiper = swiper;
  });
});


// ================= CLICK → REDIRECT =================
$(document).ready(function () {
  $('.video-slider-wrapper video').on('click', function () {
    const url = $(this).closest('video-element').attr('data-url');
    if (url) window.location.href = url;
  });
});
